const parametersToMap = () => {
  const params = document.location.search.substring(1)
  return params !== ''
    ? params.split('&').reduce((acc, param) => {
        const [name, value] = param.split('=')
        return {
          ...acc,
          [name]: acc[name] !== undefined ? [...acc[name], value] : [value]
        }
      }, {})
    : {}
}

export const parameterValues = name => {
  const param = parametersToMap()[name]
  return param !== undefined
    ? param.map(
        value => (value !== undefined ? decodeURIComponent(value) : undefined)
      )
    : []
}

export const parameterValue = name => {
  const xs = parameterValues(name)
  return xs.length === 0 ? undefined : xs[xs.length - 1]
}




// WEBPACK FOOTER //
// ./src/services/location.js